import { useMemo } from "react";
import SawmillMantine from "@graylog/sawmill/mantine";
import SawmillSC from "@graylog/sawmill/styled-components";
import usePreferredColorScheme from "theme/hooks/usePreferredColorScheme";
import usePluginEntities from "hooks/usePluginEntities";
const useMantineTheme = (colorScheme, useCustomThemeColors) => {
  var _a;
  const { data: customThemeColors } = (_a = useCustomThemeColors == null ? void 0 : useCustomThemeColors()) != null ? _a : {};
  return useMemo(
    () => SawmillMantine({
      colorScheme,
      customColors: customThemeColors == null ? void 0 : customThemeColors[colorScheme]
    }),
    [colorScheme, customThemeColors]
  );
};
const useStyledComponentsTheme = (changeColorScheme, mantineTheme) => useMemo(() => {
  const theme = SawmillSC(mantineTheme);
  return {
    ...theme,
    changeMode: changeColorScheme,
    mantine: mantineTheme
  };
}, [changeColorScheme, mantineTheme]);
const useThemes = (initialThemeModeOverride, userIsLoggedIn) => {
  var _a;
  const [colorScheme, changeColorScheme] = usePreferredColorScheme(initialThemeModeOverride, userIsLoggedIn);
  const themeCustomizer = usePluginEntities("customization.theme.customizer");
  const useCustomThemeColors = (_a = themeCustomizer == null ? void 0 : themeCustomizer[0]) == null ? void 0 : _a.hooks.useCustomThemeColors;
  const mantineTheme = useMantineTheme(colorScheme, useCustomThemeColors);
  const scTheme = useStyledComponentsTheme(changeColorScheme, mantineTheme);
  return { scTheme, mantineTheme, colorScheme };
};
export default useThemes;
